import Swal from 'sweetalert2';

const baseSwal = Swal.mixin({
  customClass: {
    popup: 'rounded-2xl',
    title: 'font-bold',
    confirmButton: 'rounded-lg px-5 py-2 text-sm font-bold whitespace-nowrap',
    cancelButton: 'rounded-lg px-5 py-2 text-sm font-bold whitespace-nowrap',
    htmlContainer: 'text-sm',
  },
  buttonsStyling: false,
});

export const SwalAlert = {
  confirm: (title: string, text: string) =>
    baseSwal.fire({
      title,
      text,
      icon: 'question',
      showCancelButton: true,
      confirmButtonText: 'Sí, continuar',
      cancelButtonText: 'Cancelar',
      confirmButtonColor: '#ef4444',
      cancelButtonColor: '#d1d5db',
    }),

  success: (title: string, text?: string) =>
    baseSwal.fire({
      title,
      text: text || '',
      icon: 'success',
      confirmButtonText: 'OK',
      confirmButtonColor: '#10b981',
      timer: 2500,
      timerProgressBar: true,
    }),

  error: (title: string, text?: string) =>
    baseSwal.fire({
      title,
      text: text || '',
      icon: 'error',
      confirmButtonText: 'Entendido',
      confirmButtonColor: '#ef4444',
    }),

  warning: (title: string, text?: string) =>
    baseSwal.fire({
      title,
      text: text || '',
      icon: 'warning',
      confirmButtonText: 'Entendido',
      confirmButtonColor: '#f59e0b',
    }),

  noConnection: (title: string, text: string, actionLabel?: string) => {
    const hasAction = !!actionLabel;
    return baseSwal.fire({
      title,
      text,
      icon: 'warning',
      confirmButtonText: actionLabel || 'Entendido',
      confirmButtonColor: '#f59e0b',
      ...(hasAction
        ? {}
        : { showCancelButton: false }),
    });
  },

  saved: (title?: string) =>
    baseSwal.fire({
      title: title || 'Datos guardados',
      text: 'Los cambios se guardaron correctamente.',
      icon: 'success',
      confirmButtonText: 'OK',
      confirmButtonColor: '#10b981',
      timer: 2000,
      timerProgressBar: true,
    }),

  cancelled: () =>
    baseSwal.fire({
      title: 'Cambios cancelados',
      text: 'No se realizaron modificaciones.',
      icon: 'info',
      confirmButtonText: 'OK',
      confirmButtonColor: '#6b7280',
      timer: 2000,
      timerProgressBar: true,
    }),

  loading: (title: string, text?: string) =>
    baseSwal.fire({
      title,
      text: text || 'Por favor esperá...',
      allowOutsideClick: false,
      allowEscapeKey: false,
      showConfirmButton: false,
      didOpen: () => {
        Swal.showLoading();
      },
    }),

  toast: (title: string, icon: 'success' | 'error' | 'warning' | 'info' = 'success') =>
    baseSwal.fire({
      toast: true,
      position: 'top-end',
      title,
      icon,
      showConfirmButton: false,
      timer: 2500,
      timerProgressBar: true,
    }),

  selectModal: (
    title: string,
    options: Record<string, string>,
    placeholder?: string,
  ) =>
    baseSwal.fire({
      title,
      input: 'select',
      inputOptions: options,
      inputPlaceholder: placeholder || 'Seleccioná una opción',
      showCancelButton: true,
      confirmButtonText: 'Seleccionar',
      cancelButtonText: 'Cancelar',
      confirmButtonColor: '#0ea5e9',
      cancelButtonColor: '#d1d5db',
      inputValidator: (value) => {
        if (!value) {
          return 'Tenés que seleccionar una opción';
        }
        return undefined;
      },
    }),
};